import api from "./api";

const timetableService = {
  // ==================== TIMETABLE VIEWING ====================
  getTimetable: (params) => api.get("/timetable-generation", { params }),

  getClassTimetable: (classId) => api.get(`/timetable-generation/class/${classId}`),

  getTeacherTimetable: (teacherId, params) => api.get(`/timetable-generation/teacher/${teacherId}`, params ? { params } : undefined),

  getStudentTimetable: (studentId) => {
    return api.get(`/timetable-generation/student/${studentId}`);
  },

  // ==================== TIMETABLE GENERATION (GA-BASED) ====================
  
  // Preview/Check Feasibility - Check if timetable can be generated
  previewTimetable: (params) => api.post("/timetable-generation/preview", params),

  // Generate Timetable - Create new timetable using Genetic Algorithm
  generateTimetable: (params) => api.post("/timetable-generation/generate", params),

  // Get All Timetables - List all generated timetables
  getAllTimetables: (params) => api.get("/timetable-generation", { params }),

  // Get filter options (academic years, statuses) for timetable listing
  getFilterOptions: () => api.get("/timetable-generation/filter-options"),

  // Get Timetable by ID - Get specific timetable with all slots
  getTimetableById: (id) => api.get(`/timetable-generation/${id}`),

  /** GET /api/v1/timetable-generation/lecture-modes/:timetableId */
  getLectureModes: (timetableId) =>
    api.get(`/timetable-generation/lecture-modes/${timetableId}`),

  // Toggle Timetable Status - Lock/Unlock timetable
  toggleTimetableStatus: (id, params) => 
    api.patch(`/timetable-generation/${id}/activate`, params),

  // Update editable timetable metadata (name, academicYear, departmentId)
  updateTimetableMeta: (id, body) =>
    api.patch(`/timetable-generation/${id}/metadata`, body),

  // Lock/Finalize Timetable
  lockTimetable: (id) => 
    api.patch(`/timetable-generation/${id}/activate`, { isActive: true }),

  // Unlock Timetable
  unlockTimetable: (id) => 
    api.patch(`/timetable-generation/${id}/activate`, { isActive: false }),

  // Delete Timetable
  deleteTimetable: (id) => api.delete(`/timetable-generation/${id}`),

  // Regenerate Timetable - Generate new version with locked slots
  regenerateTimetable: (id, params) => 
    api.post(`/timetable-generation/${id}/regenerate`, params),

  // Export Timetable - Download in JSON, CSV, Excel, or PDF format
  exportTimetable: (id, format = 'json') =>
    api.get(`/timetable-generation/${id}/export`, {
      params: { format },
      responseType: ['csv', 'excel', 'xlsx', 'pdf'].includes(format) ? 'blob' : 'json',
    }),

  // Get Timetable Analytics - View statistics and quality metrics
  getTimetableAnalytics: (id) => api.get(`/timetable-generation/${id}/analytics`),

  // ==================== SLOT MANAGEMENT ====================
  createTimetableFromScratch: (data) =>
    api.post("/timetable-generation/from-scratch", data),

  createSlot: (timetableId, entryData) =>
    api.post(`/timetable-generation/${timetableId}/slots`, entryData),

  updateSlot: (timetableId, slotId, entryData) =>
    api.put(`/timetable-generation/${timetableId}/slots/${slotId}`, entryData),

  deleteSlot: (timetableId, slotId) =>
    api.delete(`/timetable-generation/${timetableId}/slots/${slotId}`),

  validateSlot: (timetableId, slotData) =>
    api.post(`/timetable-generation/${timetableId}/validate-slot`, slotData),

  createTimetableEntry: (entryData) => api.post("/timetable", entryData),

  updateTimetableEntry: (id, entryData) =>
    api.put(`/timetable/${id}`, entryData),

  deleteTimetableEntry: (id) => api.delete(`/timetable/${id}`),

  // ==================== SCHEDULE CHANGE REQUESTS ====================
  requestScheduleChange: (requestData) =>
    api.post("/timetable-generation/request-change", requestData),

  getScheduleChangeRequests: (params) =>
    api.get("/timetable-generation/change-requests", { params }),

  approveScheduleChange: (requestId) =>
    api.post(`/timetable-generation/change-requests/${requestId}/approve`),

  rejectScheduleChange: (requestId, reason) =>
    api.post(`/timetable-generation/change-requests/${requestId}/reject`, { reason }),

  updateScheduleChangeRequest: (requestId, body) =>
    api.put(`/timetable-generation/change-requests/${requestId}`, body),

  cancelScheduleChangeRequest: (requestId) =>
    api.delete(`/timetable-generation/change-requests/${requestId}`),

  // ==================== LEGACY/DEPRECATED ====================
  downloadTimetable: (classId) =>
    api.get(`/timetable/download/${classId}`, {
      responseType: "blob",
    }),
};

export default timetableService;
